import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Query } from 'react-apollo';
import gql from 'graphql-tag';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';

import { withAccount } from '../../../../../components/AccountContext';
import ImportDefinitionList from './ImportDefinitionList';
import { parse, filterPaginationWithSize, emptyConnection } from '../../../../../utils/UrlUtil';

export const LIST_QUERY = gql`
  query(
    $accountId: ID!
    $importId: ID!
    $filter: SurveyDefinitionFilter
    $first: Int
    $after: String
    $last: Int
    $before: String
    $sort: SurveyDefinitionSortSpecifier
  ) {
    account(id: $accountId) {
      id
      surveyImport(id: $importId) {
        id
        surveyDefinitions(filter: $filter, first: $first, after: $after, last: $last, before: $before, sort: $sort) {
          edges {
            cursor
            node {
              id
              tags
              commentsEnabled
              name
              selfEmail
            }
          }
          pageInfo {
            startCursor
            endCursor
            hasPreviousPage
            hasNextPage
          }
          totalCount
          indexFrom
          indexTo
        }
      }
    }
  }
`;

class ImportDefinitionListContainer extends Component {
  render() {
    const { currentAccount, location, match } = this.props;
    const params = parse(location.search);
    const pagination = filterPaginationWithSize(params);
    const { importId } = match.params;
    const variables = {
      ...pagination,
      importId,
      accountId: currentAccount,
      sort: params.sort,
      filter: params.filter,
    };
    return (
      <Query query={LIST_QUERY} variables={variables} fetchPolicy="network-only">
        {({ data, loading, error }) => {
          if (error) return `Error! ${error.message}`;

          const connection = data && data.account && data.account.surveyImport
            ? data.account.surveyImport.surveyDefinitions
            : emptyConnection();

          return <ImportDefinitionList connection={connection} currentAccount={currentAccount} loading={loading} />;
        }}
      </Query>
    );
  }
}

ImportDefinitionListContainer.propTypes = {
  location: PropTypes.objectOf(PropTypes.any).isRequired,
  currentAccount: PropTypes.string.isRequired,
  match: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default withRouter(injectIntl(withAccount(ImportDefinitionListContainer)));
